import {OldEmitterConfig} from "pixi-particles";

export class ParticleSettings {
    public static readonly coinsConfigs: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.76,
            "end": 1,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 700,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1500
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 5,
            "max": 5
        },
        "blendMode": "normal",
        "frequency": 0.06,
        "emitterLifetime": -1,
        "maxParticles": 150,
        "pos": {
            "x": 1280 / 2,
            "y": 720 + 40,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -380,
            "y": -25,
            "w": 200,
            "h": 50
        }
    };

    public static readonly coinsConfigsSplash: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.76,
            "end": 1,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 700,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1500
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 5,
            "max": 5
        },
        "blendMode": "normal",
        "frequency": 0.001,
        "emitterLifetime": 0.5,
        "maxParticles": 50,
        "pos": {
            "x": 1280 / 2,
            "y": 720 + 40,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -380,
            "y": -25,
            "w": 200,
            "h": 50
        }
    };
}